<template lang="html">
  <div v-if="document" :style="selfStyle"><span class="tooltip-up" :class="spanClass"
                                                data-placement="top"
                                                :title="tooltipTitle"
                                                data-toggle="tooltip"></span></div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'legacy-history-document-status-icon',
})
export default class LegacyHistoryDocumentStatusIcon extends Vue {
  @Prop({required: true})
  document: any

  @Prop({default: 'Платеж исполнен.'})
  titleExecuted!: string

  @Prop({default: 'Платеж переведен на ручную обработку. Наш персонал постарается обработать вашу заявку максимально быстро. Благодарим за понимание.'})
  titleManualProcess!: string

  @Prop({default: 'Платеж отклонен.'})
  titleDeclined!: string

  @Prop({default: 'Платеж в обработке.'})
  titleInprocess!: string

  mounted() {
    // $('span', this.el).tooltip({
    //     template: '<div class="tooltip tooltip-up" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    //     trigger: 'hover focus click'
    // });
  }

  get selfStyle(): any {
    return {
      position: 'relative',
      margin: '0 auto',
      width: '45px',
    };
  }

  get tooltipTitle(): string {
    // if (this.document.inprocessmanual || (this.document.state == 'inprocess_manual')) return this.titleManualProcess;
    if (this.document.state == 'inprocess') return this.titleInprocess;
    if ((this.document.state == 'executed')
      || (this.document.state == 'virtual')) return this.titleExecuted;
    if (this.document.state == 'declined') return this.document.comment ? this.document.comment : this.titleDeclined;
    return this.titleInprocess;
  }

  get spanClass(): any {
    // if (this.document.inprocessmanual || (this.document.state == 'inprocess_manual')) return 'payment-status_deferred';
    if (this.document.state == 'inprocess') return 'payment-status_processing';
    if (
      (this.document.state == 'executed')
      || (this.document.state == 'virtual')
      ) return 'payment-status_accepted';
    if (this.document.state == 'declined') return 'payment-status_rejected';
    // if (this.document.state == 'inprocess_manual') return 'payment-status_deferred';
    // if (this.document.state == 'unsigned') return 'payment-status_deferred';
    return 'payment-status_processing';
  }
}
</script>

<style scoped lang="less">

</style>
